module.exports = __webpack_public_path__ + "static/media/morning-star3.956ffa7c.jpg";